export interface Vej {
    id: number;
    navn: string;
    postNr: string;
}
